import React from "react";
import { Select, SelectProps } from "@chakra-ui/react";

import { PossibleLocationsOrAll, MODULE_LOCATIONS } from "@constants";

type LocationSelectProps = SelectProps & {
  location: PossibleLocationsOrAll;
  setLocation: (location: PossibleLocationsOrAll) => void;
};

export function LocationSelect({
  location,
  setLocation,
  ...delegated
}: LocationSelectProps) {
  return (
    <Select
      value={location}
      onChange={(evt) =>
        setLocation(evt.target.value as PossibleLocationsOrAll)
      }
      {...delegated}
    >
      {["All", ...Object.values(MODULE_LOCATIONS)].map((loc) => (
        <option key={loc} value={loc}>
          {loc}
        </option>
      ))}
    </Select>
  );
}
